import type { ReactNode } from "react";
import { Popover } from "orcs-design-system";

import { OPTION_WRITES_BLOCKED_MESSAGE } from "./useOptionWritesBlocked";

type OptionWritesBlockedPopoverProps = {
  blocked: boolean;
  children: ReactNode;
};

/** Explains why a disabled control is disabled while a design option is selected. */
const OptionWritesBlockedPopover = ({
  blocked,
  children,
}: OptionWritesBlockedPopoverProps) =>
  blocked ? (
    <Popover direction="left" text={OPTION_WRITES_BLOCKED_MESSAGE}>
      {children}
    </Popover>
  ) : (
    <>{children}</>
  );

export default OptionWritesBlockedPopover;
